import Statistics from './Pages/Dashboard/Statistics';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Pages/Login/Login';
import Events from './Pages/Dashboard/Events';
import LegalDocuments from './Pages/Dashboard/LegalDocuments';
import Prices from './Pages/Dashboard/Prices';
import Users from './Pages/Dashboard/Users';
import Loader from './Components/Loader/Loader';
import Sidebar from './Components/Sidebar/Sidebar';
import { supabase } from './Services/supabaseClient';
import Photographers from './Pages/Dashboard/Photographers';
import Photos from './Pages/Dashboard/Photos';
import Survey from './Pages/Dashboard/Survey';
import Event from './Pages/Dashboard/Event';
import EventAttendees from './Pages/Dashboard/EventAttendees';
import E2ETest from './Pages/Dashboard/E2ETest';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('a_access_token');
    if (token && !user) {
      supabase.auth.getUser(token).then(({ data }) => {
        if (data?.user && data.user.email === 'prendizg@gmail.com') {
          setUser(data.user);
        } else {
          localStorage.removeItem('a_access_token');
        }
      });
    }
    setLoading(false);
  }, [user]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      {!user ? (
        <Routes>
          <Route
            path="/login"
            element={<Login onLogin={setUser} />}
          />
          <Route
            path="*"
            element={<Navigate to="/login" replace />}
          />
        </Routes>
      ) : (
        <div style={{ display: 'flex' }}>
          <Sidebar />
          <div style={{ flex: 1, paddingTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
            <Routes>
              <Route path="/events" element={<Events user={user} />} />
              <Route path="/events/:id" element={<Event user={user} />} />
              <Route path="/events/attendees/:id" element={<EventAttendees user={user} />} />
              <Route path="/legal-documents" element={<LegalDocuments user={user} />} />
              <Route path="/prices" element={<Prices user={user} />} />
              <Route path="/users" element={<Users user={user} />} />
              <Route path="/photographers" element={<Photographers user={user}/>} />
              <Route path="/photos" element={<Photos user={user}/>} />
              <Route path="/survey" element={<Survey user={user}/>} />
              <Route path="/dashboard" element={<Statistics user={user}/>} />
              <Route path="/e2e-test" element={<E2ETest user={user}/>} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </div>
      )}
    </Router>
  );
}

export default App;
